import {
  GET_POST_ITEMS,
  GET_POST_ITEMS_SUCCESS,
  GET_POST_ITEMS_ERROR,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  CREATE_POST_NEW_RECORD,
  CREATE_POST_NEW_RECORD_SUCCESS,
  CREATE_POST_NEW_RECORD_ERROR
} from '../actions';

export const getPostItem = (postId) => ({
  type: GET_POST_ITEMS,
  payload: { postId }
});

export const getPostItemSuccess = (postItem) => ({
  type: GET_POST_ITEMS_SUCCESS,
  payload: {postItem}
});

export const getPostItemError = (message) => ({
  type: GET_POST_ITEMS_ERROR,
  payload: { message }
});

export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const createNewRecord = (postItem, history) => ({
    type: CREATE_POST_NEW_RECORD,
    payload: {postItem, history}
  });

export const createNewRecordSuccess = (recordCreated) => ({
  type: CREATE_POST_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createNewRecordError = (message) => ({
  type: CREATE_POST_NEW_RECORD_ERROR,
  payload: { message },
});

